/** Check that format contains "%Y", and either "%I" or "%0NI", where N is any number. */
export function isFormatValid(format: string | null) {
  if (!format || typeof format !== "string") {
    return false;
  }

  const hasYear = format.includes("%Y");
  const hasNumber = format.includes("%l") || /%0\d+l/.test(format);

  return hasYear && hasNumber;
}
